import React, { useEffect, useState } from "react";
import { TextField, PrimaryButton } from "@fluentui/react";
import CommonDataTable from "../CommonDataTable";
import {
  GetAmsDataByJobId,
  UpdateJobReviewAmsStatus,
} from "../../Services/JobConfigurationServices";
import { SimpleSnackbar } from "../SnackBar";

const AmsAction = () => {
  const [searchText, setSearchText] = useState("");
  const [record, setRecord] = useState([]);
  const reference = React.useRef();

  const column = [
    {
      name: "Job Id",
      selector: (row) => row?.JobId,
      style: { fontSize: "9px !important" },
      width: "180px",
    },
    {
      name: "ReviewStatus",
      selector: (row) => {
        if (row?.ReviewStatus) {
          return <span style={{ color: "green" }}>Completed</span>;
        } else {
          return <span style={{ color: "red" }}>NA</span>;
        }
      },
      wrap: true,
      style: { fontSize: "9px !important" },
      width: "150px",
    },
    {
      name: "Reviwed By",
      selector: (row) => row?.ReviewedBy,
      wrap: true,
      style: { fontSize: "9px !important" },
      width: "200px",
    },
    {
      name: "Dispatched By",
      selector: (row) => row?.DispatchedBy,
      style: { fontSize: "9px !important" },
      width: "200px",
    },
    {
      name: "AmsStatus",
      selector: (row) => {
        if (row?.AmsStatus) {
          return <span style={{ color: "green" }}>Completed</span>;
        } else {
          return <span style={{ color: "red" }}>NA</span>;
        }
      },
      style: { fontSize: "9px !important" },
      width: "100px",
    },
    {
      name: "AmsCompleted By",
      selector: (row) => row?.AmsCompletedBy,
      style: { fontSize: "9px !important" },
      width: "200px",
    },
    {
      name: "Action",
      cell: (row) => {
        if (!row?.AmsStatus && row?.ReviewStatus && row?.IntStatus === 9) {
          return (
            <PrimaryButton
              className="ref_button"
              text={
                <span
                  style={{
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Complete AMS Update
                </span>
              }
              styles={{
                rootHovered: {
                  backgroundColor: "#251ca8",
                },
              }}
              onClick={() => {
                updateStatus(row?.JobId);
              }}
            />
          );
        }
      },
    },
  ];

  const filterData = async (JobId) => {
    document.body.classList.add("loading-indicator");
    try {
      let text_to_search = JobId || searchText;
      if (text_to_search) {
        text_to_search = text_to_search.trim();
      }
      const data = await GetAmsDataByJobId(text_to_search, '', '', '');
      if (data && Array.isArray(data)) {
        setRecord(data);
      } else {
        setRecord([]);
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator");
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  const updateStatus = async (JobId) => {
    document.body.classList.add("loading-indicator");
    try {
      if (JobId) {
        const data = await UpdateJobReviewAmsStatus(JobId.trim());
        if (data === "success") {
          reference?.current?.showSnackbar(
            "AMS Update Completed Successfully",
            "success",
            true
          );
        }
        await filterData(JobId);
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator");
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  return (
    <div style={{ padding: "10px" }}>
      <b>Ams Action Section</b>
      <div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <TextField
            placeholder="Search JobId..."
            value={searchText}
            onChange={(e, newValue) => {
              setSearchText(newValue);
            }}
            style={{
              width: "250px",
              marginRight: "8px",
            }}
          />
          <PrimaryButton
            text={
              <span style={{ color: "white", fontWeight: "bold" }}>Search</span>
            }
            onClick={() => {
              filterData();
            }}
            style={{
              marginLeft: "-50px",
              height: "32.1px",
              fontSize: "10px",
            }}
          />
        </div>
        <br />
        <div>
          <CommonDataTable
            key={"jData"}
            column={column}
            data={record}
            headerFontSize="10px"
          />
        </div>
        <SimpleSnackbar ref={reference} />
      </div>
    </div>
  );
};

export default AmsAction;
